import React, { Component } from 'react';
import FormItem from '../../../components/FormItem/index';
import { Form, Input, Button, message, TreeSelect } from 'antd';
import services from '../../../services/api';
import { deepCopy } from '../../../utils/utils';

class MenuAdd extends Component {
  constructor() {
    super();
    this.state = {
      treeData: []
    };
  }

  componentDidMount() {
    this.resetData();
  }

  resetData = () => {
    const value = this.props.record ? this.props.record.value : undefined;
    const copyTree = deepCopy(this.props.treeData);
    const treeData = copyTree.map(item => {
      return this.disabledTree(item, value);
    });
    this.setState({
      treeData: treeData
    });
  };

  disabledTree = (item, value, disabled) => {
    if (item.value === value || disabled) {
      item.disabled = true;
    }
    if (item.children && item.children.length > 0) {
      item.children = item.children.map(it => {
        if (item.disabled) {
          return this.disabledTree(it, value, true);
        } else {
          return this.disabledTree(it, value);
        }
      });
    }
    return item;
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // 如果是更新操作，需指定id
        if (this.props.actionType === 'update') {
          values.id = this.props.record.value;
        }
        values.right_level = parseInt(values.right_level, 10);
        services.menuConfig[this.props.actionType](values).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            this.props.closeModal();
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    const { title, pid, url, icon, right_level } = this.props.record || {};

    const formItems = [
      {
        label: {
          label: '菜单名',
          className: 'tantuer-form-item'
        },
        name: 'name',
        options: {
          initialValue: title,
          rules: [{ required: true, message: '请输入菜单名' }]
        },
        component: <Input placeholder="菜单名" className="large" />
      },
      {
        label: {
          label: '上级菜单',
          className: 'tantuer-form-item'
        },
        name: 'pid',
        options: {
          initialValue: pid
        },
        component: (
          <TreeSelect
            style={{ width: 300 }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={this.state.treeData}
            placeholder="请选择上级菜单"
            treeDefaultExpandAll
          />
        )
      },
      {
        label: {
          label: '菜单路由',
          className: 'tantuer-form-item'
        },
        name: 'url',
        options: {
          initialValue: url,
          rules: [{ required: true, message: '请输入菜单路由' }]
        },
        component: <Input placeholder="菜单路由" className="default" />
      },
      {
        label: {
          label: '菜单Icon',
          className: 'tantuer-form-item'
        },
        name: 'icon',
        options: {
          initialValue: icon
        },
        component: <Input placeholder="菜单Icon" className="small" />
      },
      {
        label: {
          label: '权限',
          className: 'tantuer-form-item'
        },
        name: 'right_level',
        options: {
          initialValue: right_level
        },
        component: <Input placeholder="权限" className="small" />
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems.map((item, key) => {
              return <FormItem key={key} form={this.props.form} item={item} />;
            })}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(MenuAdd);
